// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/transfer_history.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { TransferHistoryItem, TransferHistoryStatus } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.TransferHistoryRequest
 */
export class TransferHistoryRequest extends Message<TransferHistoryRequest> {
  /**
   * The ID of the stock point to filter transfer history by source stock point.
   *
   * @generated from field: string source_stock_point_id = 1;
   */
  sourceStockPointId = "";

  /**
   * The ID of the stock point to filter transfer history by destination stock point.
   *
   * @generated from field: string destination_stock_point_id = 2;
   */
  destinationStockPointId = "";

  /**
   * Page number for pagination.
   *
   * @generated from field: int32 page_number = 3;
   */
  pageNumber = 0;

  /**
   * Number of items per page.
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize = 0;

  /**
   * Status of the transfer history items to filter by.
   *
   * @generated from field: com.neulink.pharmacy.TransferHistoryStatus status = 5;
   */
  status = TransferHistoryStatus.UNSPECIFIED;

  constructor(data?: PartialMessage<TransferHistoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TransferHistoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "source_stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "destination_stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(TransferHistoryStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TransferHistoryRequest {
    return new TransferHistoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TransferHistoryRequest {
    return new TransferHistoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TransferHistoryRequest {
    return new TransferHistoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TransferHistoryRequest | PlainMessage<TransferHistoryRequest> | undefined, b: TransferHistoryRequest | PlainMessage<TransferHistoryRequest> | undefined): boolean {
    return proto3.util.equals(TransferHistoryRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.TransferHistoryResponse
 */
export class TransferHistoryResponse extends Message<TransferHistoryResponse> {
  /**
   * List of transfer history items matching the criteria.
   *
   * @generated from field: repeated com.neulink.pharmacy.TransferHistoryItem transfer_history = 1;
   */
  transferHistory: TransferHistoryItem[] = [];

  /**
   * Total number of transfer history items matching the criteria.
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<TransferHistoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TransferHistoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "transfer_history", kind: "message", T: TransferHistoryItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TransferHistoryResponse {
    return new TransferHistoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TransferHistoryResponse {
    return new TransferHistoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TransferHistoryResponse {
    return new TransferHistoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TransferHistoryResponse | PlainMessage<TransferHistoryResponse> | undefined, b: TransferHistoryResponse | PlainMessage<TransferHistoryResponse> | undefined): boolean {
    return proto3.util.equals(TransferHistoryResponse, a, b);
  }
}

